// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__GKLaF","default":"IconButton_default__m9t-p","dark":"IconButton_dark__eN7Bj","danger":"IconButton_danger__AHRdR"};